export default __webpack_public_path__ + "static/media/ic_school.3a2ab78c.svg";